var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bannerModelEditor',{attrs:{"formDataItem":_vm.formDataItem},model:{value:(_vm.banner),callback:function ($$v) {_vm.banner=$$v},expression:"banner"}})}
var staticRenderFns = []

export { render, staticRenderFns }